import { render, staticRenderFns } from "./StoryblokHeroGallery.vue?vue&type=template&id=6aee4de3&"
import script from "./StoryblokHeroGallery.vue?vue&type=script&lang=ts&"
export * from "./StoryblokHeroGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports